import * as R from 'ramda';
import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectIftaReportStore = (state) => state.iftaReport;

const makeSelectItemList = () => createSelector(
  selectIftaReportStore,
  R.compose(
    R.sortBy(R.prop('index')),
    R.values,
    R.path(['itemList']),
  ),
);

const makeSelectAdditionalFilters = () => createSelector(
  selectIftaReportStore,
  ({ additionalFilters }) => additionalFilters,
);

const makesSelectTotalCount = () => createSelector(
  selectIftaReportStore,
  ({ totalCount }) => totalCount,
);

const makeSelectPagination = () => createSelector(
  selectIftaReportStore,
  ({ pagination }) => pagination,
);

const makeSelectTruckGuid = () => createSelector(
  selectIftaReportStore,
  ({ truckGuid }) => truckGuid,
);

const makeSelectListLoading = () => createSelector(
  selectIftaReportStore,
  ({ loading }) => loading,
);

const makeSelectAvailableReports = () => createSelector(
  selectIftaReportStore,
  ({ availableReports }) => availableReports,
);

const makeSelectUsedReport = () => createSelector(
  selectIftaReportStore,
  ({ usedReport }) => usedReport,
);

const makeSelectReportStatus = () => createSelector(
  selectIftaReportStore,
  ({ reportPending }) => reportPending,
);

const makeSelectTitleSortValues = () => createSelector(
  selectIftaReportStore,
  ({ titleSortValues }) => titleSortValues,
);

const makeSelectTableTitleFilters = () => createSelector(
  selectIftaReportStore,
  ({ tableTitleFilters }) => tableTitleFilters,
);

export {
  makeSelectItemList,
  makeSelectTruckGuid,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectListLoading,
  makesSelectTotalCount,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectAdditionalFilters,
};
